export function convertSpectraArrayToObject(spectra) {
    const spectraObject = {};
    for (const spectrum of spectra)
        spectraObject[spectrum.id] = spectrum;
    return spectraObject;
}
